import { render, staticRenderFns } from "./PageSupplierOrders.vue?vue&type=template&id=d6fad3a2&scoped=true&"
import script from "./PageSupplierOrders.vue?vue&type=script&lang=js&"
export * from "./PageSupplierOrders.vue?vue&type=script&lang=js&"
import style0 from "./PageSupplierOrders.vue?vue&type=style&index=0&id=d6fad3a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6fad3a2",
  null
  
)

export default component.exports